import { render, staticRenderFns } from "./AssignedScopesCard.vue?vue&type=template&id=1ca10f92&"
import script from "./AssignedScopesCard.vue?vue&type=script&lang=js&"
export * from "./AssignedScopesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports